module.exports = __webpack_public_path__ + "img/fc16bb7.jpg";